import React from 'react';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {DialogHeaderBox} from '../../boxes/header/dialog-header.box';
import {DialogTitleBox} from '../../boxes/title/dialog-title.box';
import {DialogCloseButtonBox} from '../../boxes/close-button/dialog-close-button.box';
import {CyClass} from '../../../../../common/cy-classes';

export interface ModalDialogHeaderComponentProps {
    title?: string;
    hideCloseButton?: boolean;
    onCloseButtonClick?: () => void;
    className?: string;
}
export class DialogHeaderComponent extends OrbitComponent<ModalDialogHeaderComponentProps> {

    private _renderTitle() {
        if(!this.props.title) {
            return null;
        }

        return (<DialogTitleBox className='dialog-header-title'>
            {this.props.title}
        </DialogTitleBox>);
    }

    private _renderCloseButton() {
        if(this.props.hideCloseButton) {
            return null;
        }

        return <DialogCloseButtonBox className={CyClass('cy-modal-dialog-x-close-button')} onClick={this.props.onCloseButtonClick}/>
    }

    private _renderContent() {
        if (this.props.children) {
            return this.props.children
        }

        return (
            <>
                {this._renderTitle()}
                {this._renderCloseButton()}
            </>
        );
    }

    render() {
        if(!this.props.title && this.props.hideCloseButton && !this.props.children) {
            return null;
        }

        let height: number | null = null;
        if(this.services.miniOrbit.isEnabled) {
            //for miniOrbit we want total height of header to be headerHeight
            //but in ModalDialogComponent we already added top space of headerRegulationDataHeight
            //so remaining space should be: headerHeight - headerRegulationDataHeight
            height = this.services.header.headerHeight - this.services.header.headerRegulationDataHeight;
        }

        return (
            <DialogHeaderBox className={`${CyClass('cy-modal-dialog-header')} ${this.props.className? this.props.className : ''}`} height={height}>
                {this._renderContent()}
            </DialogHeaderBox>
        )
    }

}